<template>
  <v-app>
    <v-app-bar
      fixed
      app
      :color="!$vuetify.theme.dark ? 'primary' : ''"
      dark
      clipped-left
      elevation="1"
    >
      <v-app-bar-nav-icon @click="toggleSidebar">
        <v-icon>mdi-{{ !mini ? 'menu-open' : 'menu' }} </v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title 
        v-if="$vuetify.breakpoint.lgAndUp"
        class="ml-0 pl-4"
      >
        <span class="font-weight-regular" style="font-size: 18px;">
          QUẢN TRỊ HỆ THỐNG KẾT NỐI NÔNG NGHIỆP
        </span>
      </v-toolbar-title>
      <span v-else>
        MENU
      </span>
      <v-spacer/>
      <v-switch
        v-model="darkMode"
        inset
        color="orange"
        hide-details
        class="mr-6"
      >
        <template v-slot:label>
          <span class="font-italic">
            {{!darkMode ? 'Sáng' : 'Tối'}}
          </span>
        </template>
      </v-switch>
      <v-btn icon @click="showHelpDialog">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-badge
        v-if="$can('lien-he-xem')"
        top
        right
        color="error"
        :content="contactCounter > 0 ? contactCounter : '0'"
        offset-x="20"
        offset-y="20"
      >
        <v-btn icon :class="{ 'bounce': contactCounter > 0 }"
          :to="{path: '/admin/contacts'}"
        >
          <v-icon>mdi-bell-ring-outline</v-icon>
        </v-btn>
      </v-badge>
      <v-menu offset-y="offset-y">
        <template v-slot:activator="{ on }">
          <v-avatar 
            size="36px" 
            v-on="on" 
            class="ml-4" 
            style="cursor: pointer;"
          >
            <v-img 
              v-if="authMod.user.user.info.anh_dai_dien"
              :src="`${apiBaseUrl}/uploads/${authMod.user.user.info.anh_dai_dien}`"
            />
            <v-img v-else src="@/assets/user-default.jpg"/>
          </v-avatar>
        </template>
        <v-list nav dense>
          <v-list-item :to="{name: 'Home'}" exact>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trang cổng</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showProfileDialog">
            <v-list-item-icon>
              <v-icon>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Thông tin cá nhân</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="changePassword">
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Đổi mật khẩu</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="getDocument">
            <v-list-item-icon>
              <v-icon>mdi-book-open-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Hướng dẫn sử dụng</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logoutConfirm()">
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Đăng xuất</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer 
      app
      clipped
      v-model="drawer"
      :mini-variant.sync="mini"
      src="@/assets/sidebar-bg.jpg"
      class="rounded-r-lg admin-side"
      dark
    >
      <v-list class="sidebar-menu" dark>
        <template>
          <div v-for="item in menu.admin" :key="item.title">
            <template v-if="item.items">
              <v-list-group 
                v-if="checkPerm(item)"
                v-model="item.active" 
                :prepend-icon="item.action" 
                no-action 
                link
                append-icon="mdi-menu-down"
                color="yellow"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"/>
                  </v-list-item-content>
                </template>
                <template 
                  v-for="subItem in item.items">
                  <v-list-item 
                    :key="subItem.title" 
                    :to="subItem.to">
                    <v-list-item-content>
                      <v-list-item-title v-text="subItem.title"/>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
            <template v-else>
              <v-list-item-group
                v-if="checkPerm(item)"
                v-model="selectedItem"
                color="yellow"
              >
                <v-list-item :to="item.to" link>
                  <v-list-item-icon>
                    <v-icon v-text="item.action"/>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"/>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </template>
            <v-divider v-if="item.divider"/>
          </div>
        </template>
      </v-list>
      <template v-slot:append>
        <v-list>
          <v-list-item
            to="/"
            exact
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trang cổng</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-main id="admin">
      <div class="d-flex flex-column fill-height">
        <v-container fluid>
          <router-view/>
        </v-container>
      </div>
      <Footer/>
      <ScrollTop/>
    </v-main>
    <v-dialog
      v-model="dialogLogout"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Đóng ứng dụng?
        </v-card-title>
        <v-card-text>Bạn có chắc chắn bạn muốn thoát?</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="pink darken-1"
            text
            @click="dialogLogout = false"
          >
            Hủy bỏ
          </v-btn>
          <v-btn
            color="primary darken-1"
            text
            @click="logout()"
          >
            Đồng ý
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ChangePassword 
      :showDialog="dialogChangePassword" 
      :item="itemChangePassword" 
      @confirmed="onChangePasswordConfirmed" 
      @cancelled="onChangePasswordCancelled"
    />
    <Profile 
      :loading="profileLoading"
      :showDialog="profileDialog" 
      :item="userProfile" 
      @confirmed="onProfileConfirmed" 
      @cancelled="onProfileCancelled"
    />
    <Help
      :showDialog="helpDialog" 
      @cancelled="onHelpCancelled"
    />
  </v-app>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import Footer from '@/components/admin/layouts/Footer'
  import ScrollTop from '@/components/admin/layouts/ScrollTop'
  import ChangePassword from '@/views/auth/password/ChangePassword'
  import Profile from '@/views/user/Profile'
  import Help from '@/views/admin/Help'
  export default {
    components: {
      Profile,
      Footer,
      ScrollTop,
      ChangePassword,
      Help
    },
    data() {
      return {
        dialogLogout: false,
        drawer: null,
        mini: false,
        selectedItem: 1,
        userItem: {},
        darkMode: false,
        dialogChangePassword: false,
        itemChangePassword: {},
        profileLoading: false,
        profileDialog: false,
        userProfile: {},
        helpDialog: false
      }
    },
    computed: {
      ...mapState([
        'message', 
        'pageTitle', 
        'user', 
        'contactCounter',
        'menu',
        'authMod',
        'config'
      ]),
      routes() {
        return this.$route.matched.map((route) => {
          return {
            text: route.meta ? route.meta.title : route.name,
            exact: true,
            to: route.path === "" ? "/" : route.path,
            disabled: false
          };
        });
      },
      contact_num(){
        return 10
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      darkMode() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      },
    },
    mounted() {
      this.countContact()
    },
    methods: {
      ...mapActions([
        'countContact',
        'logout'
      ]),
      toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      },
      toggleSidebar() {
        if(this.$vuetify.breakpoint.lgAndUp){
          this.mini = !this.mini
        } else {
          this.drawer = !this.drawer
        }
      },
      logoutConfirm(){
        this.dialogLogout=true
      },
      checkPerm(item){
        if(!item.can){
          return true
        } else {
          if(this.$can(item.can)){
            return true
          } else {
            return false
          }
        }
      },
      changePassword(){
        this.itemChangePassword = {}
        this.dialogChangePassword = true
      },
      onChangePasswordConfirmed(item) {
        this.dialogChangePassword = false
      },
      onChangePasswordCancelled () {
        this.dialogChangePassword = false 
      },
      showProfileDialog(){
        this.profileLoading = true
        axios.get(`api/v1/users/${this.authMod.user.user.id}`)
          .then(response => {
            this.userProfile = response.data;
            this.profileLoading = false
            this.profileDialog = true
          })
          .catch(function (error) {
            console.log(error);
            this.profileLoading = false
          });
      },
      onProfileConfirmed(item) {
        this.profileDialog = false 
      },
      onProfileCancelled () {
        this.profileDialog = false 
      },
      showHelpDialog(){
        this.helpDialog = true
      },
      onHelpCancelled () {
        this.helpDialog = false 
      },
      getDocument(){
        window.open(
          `${this.config.beUrl}/document/HDSD_KetNoiNongNghiep.pdf`,
          '_blank'
        );
      }
    }
  }
</script>

<style lang="scss" scoped>
  @mixin ballb($yaxis: 0) {
    transform: translate3d(0, $yaxis, 0);
  }

  @keyframes bouncein {
    0%, 50% { @include ballb(-3px); }
    25%, 75%, 100% { @include ballb() }
  }

  .bounce {
    animation: bouncein 1500ms cubic-bezier(0.25, 0.46, 0.45, 0.94) both infinite;
  }
</style>

<style>
  .admin-side .v-image__image{
    background-position: inherit !important;
  }
</style>